<template>
  <sliding-window>
    <div slot="panel">
      <violet-bar>Présentation de l'agence</violet-bar>
      <div class="squarebox">
        <h3>Options</h3>
        <hr />
        <div>
          <div class="field">
            <label for="" class="label"
              ><input type="checkbox" v-model="options.humans" />&nbsp;Inclure
              "Équipe"</label
            >
          </div>
          <div class="field">
            <label for="" class="label"
              ><input type="checkbox" v-model="options.hardware" />&nbsp;Inclure
              "Moyens matériels"</label
            >
          </div>
        </div>
        <hr />
        <div class="field">
          <div class="control">
            <button
              class="button"
              @click="generate"
              :class="loading ? 'is-loading' : ''"
            >
              <i class="fa fa-print"></i>&nbsp;Générer le PDF
            </button>
          </div>
        </div>
        <div class="control" v-if="render">
          <hr />
          <div class="RenderPreview"><i class="fa fa-file-archive"></i></div>
          <a
            class="button is-info"
            :href="`${render.friendly_path}`"
            target="_blank"
            >Télécharger</a
          >
        </div>
      </div>
      <div class="control">
        <router-link class="button" :to="'/home'"
          ><i class="fa fa-arrow-left"></i>&nbsp;accueil
        </router-link>
      </div>
    </div>
    <page-format-handler class="about_document" :format="'A4'" v-if="form">
      <page class="scalene_about_intro">
        <img src="/pages/fond.png" alt="" class="background">
        <page-inner>
          <div class="scalene_about_title">Scalene architectes</div>
          <div class="scalene_about_bottom">Présentation de l'agence</div>
        </page-inner>
      </page>
      <page class="scalene_about_prez">
        <page-inner>
          <div class="about_document_head">
            <div>Présentation de l'agence</div>
            <div>02</div>
          </div>
          <div class="about_document_foot">
            <div>Scalene architectes</div>
            <div>{{ today_date }}</div>
          </div>
          <div class="scalene_about_page_title">Architecture enrichie</div>
          <div class="scalene_about_big_text">
            {{ form.presentation.replace("[COUPURE]", "") }}
          </div>
        </page-inner>
      </page>
      <page class="scalene_about_handlers">
        <page-inner>
          <div class="about_document_head">
            <div>Présentation de l'agence</div>
            <div>03</div>
          </div>
          <div class="scalene-handlers">
            <div
              class="scalene-handler"
              v-for="(h, i) in form.handlers"
              :key="i"
            >
              <div class="scalene-handler-title">{{ h.name }}</div>
              <div class="scalene-handler-picture">
                <api-picture :picture-id="h.picture" :lazy="false"></api-picture>
              </div>
              <div class="scalene-handler-cv">
                <div
                  class="scalene-handler-cv-line"
                  v-for="(line, j) in sort_lines(h.cv)"
                  :key="j"
                >
                  <span class="date">{{ line.date }}</span>
                  <span
                    >{{ line.text
                    }}<span
                      ><span v-if="line.city">, </span>{{ line.city }}
                      <span v-if="line.country" class="country"
                        >({{ line.country }})</span
                      ></span
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="about_document_foot">
            <div>Scalene architectes</div>
            <div>{{ today_date }}</div>
          </div>
        </page-inner>
      </page>
      <page class="scalene_team" v-if="options.humans">
        <page-inner>
          <div class="about_document_head">
            <div>Présentation de l'agence</div>
            <div>04</div>
          </div>
          <div class="scalene_about_page_title">Équipe</div>
          <div class="scalene_fake_table">
            <div class="scalene_fake_table_header">
              <ul>
                <li style="flex: 0 0 30%">Nom</li>
                <li style="flex: 0 0 40%">Poste</li>
                <li style="flex: 0 0 30%">Diplôme</li>
              </ul>
            </div>
            <div
              class="scalene_fake_table_line"
              v-for="(member, b) in form.workers"
              :key="b"
            >
              <ul>
                <li style="flex: 0 0 30%">{{ member.name }}</li>
                <li style="flex: 0 0 40%">{{ member.poste }}</li>
                <li style="flex: 0 0 30%">{{ member.diploma }}</li>
              </ul>
            </div>
          </div>
        </page-inner>
      </page>
      <page class="scalene_experiences">
        <page-inner>
          <div class="about_document_head">
            <div>Présentation de l'agence</div>
            <div>0{{ 5 + delta }}</div>
          </div>
          <div class="scalene_about_page_title">
            Publications, Expositions et Conférences
          </div>
          <div class="scalene_fake_table">
            <div class="scalene_fake_table_header">
              <ul>
                <li style="flex: 0 0 15%">Type</li>
                <li style="flex: 0 0 55%">Description</li>
                <li style="flex: 0 0 20%">Lieu</li>
                <li style="flex: 0 0 10%">Date</li>
              </ul>
            </div>
            <div
              class="scalene_fake_table_line"
              v-for="(experience, f) in sort_lines(form.cv)"
              :key="f"
            >
              <ul>
                <li style="flex: 0 0 15%">{{ experience.type }}</li>
                <li style="flex: 0 0 55%">{{ experience.description }}</li>
                <li style="flex: 0 0 20%">
                  {{ experience.city }} <span v-if="experience.country">({{ experience.country }})</span>
                  <span v-if="!experience.city && !experience.country">&mdash;</span>
                </li>
                <li style="flex: 0 0 10%">{{ experience.date }} <span v-if="!experience.date">&mdash;</span></li>
              </ul>
            </div>
          </div>
          <div class="about_document_foot">
            <div>Scalene architectes</div>
            <div>{{ today_date }}</div>
          </div>
        </page-inner>
      </page>
      <page class="scalene_hardware" v-if="options.hardware">
        <page-inner>
          <div class="about_document_head">
            <div>Présentation de l'agence</div>
            <div>0{{6 + delta}}</div>
          </div>
          <div class="scalene_about_page_title">Moyens Matériels</div>
          <div v-for="(section, a) in form.hardware" :key="a">
            <div class="scalene_hardware_title" :style="a === 0 ? ({marginTop: 0}) : {}">
              {{ section.name }}
              <span v-if="section.remark" class="scalene_hardware_title_remark">({{ section.remark }})</span>
            </div>
            <div class="scalene_fake_table">
              <div
                class="scalene_fake_table_line"
                v-for="(item, c) in section.items"
                :key="c"
              >
                <ul>
                  <li style="flex: 0 0 90%">{{ item.text }}</li>
                  <li
                    style="flex: 0 0 10%"
                    v-html="item.quantity || '&mdash;'"
                  ></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="about_document_foot">
            <div>Scalene architectes</div>
            <div>{{ today_date }}</div>
          </div>
        </page-inner>
      </page>
      <page class="scalene_closing">
        <img src="/pages/fond.png" alt="" class="background">
        <page-inner>
          <p>
            scalene<br>
          <img src="/scales.svg" alt=""><br>
          26, rue Marie Magné<br>
          31&thinsp;300 Toulouse<br>
          05&thinsp;31&thinsp;98&thinsp;22&thinsp;44<br>
          contact@scalene.fr
          </p>
          <p>
            www.scalene.fr
          </p>
        </page-inner>
      </page>
    </page-format-handler>
  </sliding-window>
</template>

<script>
import SlidingWindow from "./PrintComponents/Workspace/SlidingWindow";
import { types as t } from "../../store/actions/projects";
import { types as t2 } from "../../store/actions/misc";
import { rem } from "../../storage/storage";
import { types } from "../../store/actions/render";
import PageFormatHandler from "./PrintComponents/Page/PageFormatHandler";
import { formatDateFrench, formatNumbers, mapNames } from "./../../util/func";
import ApiPicture from "./../../components/Form/ApiPicture";
import VioletBar from "../Projects/VioletBar";
import { defaultApiUrl } from "../../api";
import Page from "./PrintComponents/Page/Page";
import PageInner from "./PrintComponents/Page/PageInner";

export default {
  name: "Index",
  components: {
    VioletBar,
    PageFormatHandler,
    ApiPicture,
    SlidingWindow,
    Page,
    PageInner,
  },
  data() {
    return {
      projects: [],
      form: null,
      today_date: new Date()
        .toISOString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("."),
      options: {
        humans: true,
        hardware: true,
        axes: false,
        high_def: false,
      },
      email: "soft@scalene.fr",
      sortedProjects: [],
      loading: false,
      render: null,
      ready: false,
      format: "A4",
      printBackground: true,
      kit: null,
      api_url: defaultApiUrl.replace("/api/", ""),
      pm: {
        format: "A4",
      },
    };
  },
  props: {
    ids: {},
  },
  computed: {
    pagesLength() {
      return this.projects.length;
    },
    delta() {
      return 0 - (this.options.humans ? 0 : 1) - (this.options.hardware ? 0 : 1);
    },
    valid_email() {
      return this.email.length > 6 && this.email.indexOf("@") !== -1;
    },
  },
  methods: {
    formatNumbers,
    mapNames,
    formatDateFrench,
    sort_lines(arr) {
      const b = arr.slice(0);
      b.sort((a, b) => (a.date || "") > (b.date || ""));
      return b;
    },
    sortProjects() {
      return this.projects;
    },
    async generate() {
      this.loading = 1;
      const render = await this.$store.dispatch(types.EXPORT_A4_PROJECT, {
        payload: JSON.stringify(this.$data),
        url: window.location.href,
        format: "A4",
        printBackground: true,
        range: `1-7`,
        timeout: 2000 + 7 * 100,
        friendly_name: `scalene-presentation-${(new Date()).toISOString()}.pdf`
      });
      this.render = render;
      this.loading = 0;
    },
  },
  async mounted() {
    this.form = await this.$store.dispatch(t2.GET_AGENCE);
    rem("payload");
  },
};
</script>

<style lang="scss">
/* eslint-disable */
$padding: 3px;
.scalene_about_intro,
.scalene_closing {
  position: relative;
  overflow:hidden;
  .background {
    position: absolute;
    left: -5px;
    top: 0;
    z-index: 0;
    width: calc(100% + 10px)!important;
    max-width: none;
    height: calc(100% + 10px)!important;
    margin: 0!important;
  }
}
.scalene_about_bottom {
  position: absolute;
  bottom: 0;
  font-size: 52px;
  font-style: italic;
  text-align: center;
  width: 100%;
  line-height: 1.1;
}
.scalene_about_prez {
}
.scalene_about_handlers {
}
.scalene-handlers {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.scalene-handler {
  flex: 0 0 calc(50% - 0.7em);
}
.scalene-handler-title {
}
.scalene-handler-picture {
  padding-top: 6px;
  margin-bottom: 10px;
}
.scalene-handler-cv {
  font-size: 11px;
}
.scalene-handler-cv-line {
  display: flex;
  border-top: 1px solid #31287c;
  padding-top: $padding;;
  padding-bottom: $padding;;
  padding-left: $padding;;
  padding-right: $padding;;
}
.scalene-handler-cv-line:last-of-type {
  border-bottom: 1px solid #31287c;
}
.scalene-handler-cv-line .country {
  text-transform: uppercase;
  display: inline;
}
.scalene-handler-cv-line .date {
  display: block;
  flex: 0 0 11ch;
}
.scalene_team {
}
.scalene_experiences {
}

.scalene_fake_table_header {
  display: flex;
  ul {
    width: 100%;
    display: flex;
  }
}
.scalene_hardware {
}
.scalene_about_title {
  font-size: 52px;
  text-align: center;
  line-height: 2;
}

.scalene_about_page_title,
.scalene-handler-title {
  font-size: 26.2px;
  text-align: center;
  margin-bottom: 2.2em;
  margin-top: 1.5em;
}

.scalene-handler-title {
  margin-top: 2.2em;
}

.scalene_about_big_text {
  font-size: 26.2px;
  line-height: 1.365;
}

.scalene_hardware_title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  margin-top: 16px;
  padding: $padding;
}
.scalene_hardware_title_remark {
  font-weight: 300;
}
.scalene_fake_table {
  display: flex;
  flex-direction: column;
}
.scalene_fake_table_header {
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 700;
  padding-left: $padding;;
  padding-right: $padding;;
}
.scalene_fake_table_line {
  display: flex;
  width: 100%;
  font-size: 11px;
  border-top: 1px solid #31287c;
  padding-left: $padding;;
  padding-right: $padding;;
  padding-top: $padding;;
  padding-bottom: $padding;;
  &:last-of-type {
    border-bottom: 1px solid #31287c;
  }
  ul {
    width: 100%;
    display: flex;
  }
}

.PPage > img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.about_document {
  color: #31287c;
}

.about_document_head,
.about_document_foot {
  width: 100%;
  left: 0;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  & > div {
    flex: 0 0 50%;
  }
  & > div + div {
    text-align: right;
  }
}
.about_document_foot {
  position: absolute;
  bottom: -16px;
  font-size: 10.7px;
}

.scalene_closing p {
  font-size: 26.2px;
  line-height: 1.365;
}

.scalene_closing img {
height: 1.9em;
width: auto;
margin: 0.5em 0;
margin-bottom: 0.2em;
}

.scalene_closing p + p {
  position: absolute;
  left: 0;
  bottom: -1em;
}
</style>
